import React from 'react';
import t from 'prop-types';

var BotonCaja = function BotonCaja(_ref) {
  var id = _ref.id,
      activa = _ref.activa,
      onAlternar = _ref.onAlternar;
  return React.createElement('div', {
    id: id,
    className: 'botonCajaLateral' + (activa ? ' activa' : ''),
    onClick: onAlternar
  }, 'Learning path');
};

BotonCaja.propTypes = process.env.NODE_ENV !== "production" ? {
  id: t.string.isRequired,
  activa: t.bool.isRequired,
  onAlternar: t.func.isRequired
} : {};
export default BotonCaja;